/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Input, Modal, Row, Table, Tooltip, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { contactSheetActions } from '../state/actions'
import { PlusCircleFilled, DeleteOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from 'react-redux';
import { ClientList } from '../../CreateOffer/components/ClientList';
import styles from "../styles/SendContactSheet.module.css"
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import SubjectLine from '../../Common/components/SubjectLine';
import EmailPreview from '../../Common/components/EmailPreview';
import { detectMobile, detectWebView } from '../../Common/utils/universalFuntions';
import axios from 'axios';
import { TitleCompanyHandle } from '../../TitleCompany/state/action';

const { confirm } = Modal;

export default function SendContactSheet({ offerId, propertyId, accessToken, setModalState, modalState, rootDocData, openFor }) {
    const dispatch = useDispatch();
    const [openClientList, setOpenClientList] = useState(false);
    const [addedClients, setAddedClients] = useState([]);
    const [selectedTitleCoRecipients, setSelectedTitleCoRecipients] = useState([]);
    const [form] = Form.useForm();
    const [subjectForm] = Form.useForm();
    const { contactSheetData } = useSelector((state) => state.contactSheetReducer);
    const [emailContents, setEmailContents] = useState('');
    const [ispreview, setIspreview] = useState({
        signaturePreview: false,
        emailPreview: false,
      });
    const handleEmailContentChange = (content) => {
        setEmailContents(content);
    };
    
    const closeClientListModal = () => {
        setOpenClientList(false);
    }

    const addClient = (selectedClient) => {
        setAddedClients((prev) => {
            const emailExists = prev.some(client => client.email === selectedClient.email);

            if (emailExists) {
                message.error("This Email is already selected.");
                return prev;
            }

            if (prev.length === 2) {
                message.error("You can add maximum 2 emails.");
                return prev;
            }

            message.success("Email Added Successfully.");
            return [...prev, { email: selectedClient.email, name: selectedClient.fullName || '', recipientType: "READ_ONLY" }];
        });
    };

    const handleAdd = (values) => {
        setAddedClients((prev) => {
            const emailExists = prev.some(client => client.email === values.email);

            if (emailExists) {
                message.error("This Email is already added.");
                return prev;
            }

            if (prev.length === 2) {
                message.error("You can add maximum 2 emails.");
                return prev;
            }

            message.success("Email Added Successfully.");
            form.resetFields();
            return [...prev, { email: values.email, name: values.name || '', recipientType: "READ_ONLY" }];
        });
    };

    const handleRemove = (email) => {
        setAddedClients((prev) => prev.filter((client) => client.email !== email));
        message.success("Email Removed Successfully.");
    };

    const handleSend = (source) => {
        let enteredMsg = document.getElementById("emailContents")?.value || emailContents;
        const subjectVal = subjectForm?.getFieldValue("subject");
        let payload = {
            offerId,
            propertyAddress: contactSheetData?.propertyAddress || "",
            emailArray: [...addedClients, ...selectedTitleCoRecipients],
            ...(enteredMsg && { emailMessage: enteredMsg }),
            openFor: modalState?.openFor,
            ...(subjectVal?.length ? {subject: subjectVal} : {}),
            ...(source === "emailPreview" && { showEmailPreview: true })
        }

        let paramData = {
            contactSheetId: contactSheetData?._id || contactSheetData?.existingContactSheetId,
        }
        dispatch(
            contactSheetActions.sendContactSheetLink({
              paramData,
              payload,
              accessToken,
              source: source === "emailPreview" ? source : null,
            })
          );
        if(source!=="emailPreview"){
        setModalState((prev) => ({ ...prev, openSendEmailModal: false, openFor: "" }));
        }
    }
    const {emailPreviewData} = useSelector((state) => state.contractStore);
    const isInWebView = detectWebView() 

 useEffect(() => {
   if (ispreview?.emailPreview && emailPreviewData) {
     const emailPreviewProps = {
       ispreview,
       subjectForm,
       source: "Contact_Sheet",
       emailPreviewData,
     };

     localStorage.setItem("emailPreviewProps", JSON.stringify(emailPreviewProps));
     if (isInWebView) {
       let emailPreviewPropsData = {
         eventType: "OPEN_EMAIL_PREVIEW",
         emailPreviewProps: emailPreviewProps,
       };
       window?.ReactNativeWebView?.postMessage(JSON.stringify(emailPreviewPropsData));
     } else {
       window.open("/emailPreview", "_blank");
     }
   }
 }, [emailPreviewData]);
 
    const formats = [
        'header', 'bold', 'italic', 'underline', 'strike', 'list', 'indent', 'color', 'align', 'background'
    ];

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }]
        ]
    };
const handleOpenEmailPreview = () => {
  handleSend("emailPreview");
  setIspreview({ ...ispreview, emailPreview: true });
};
const handleCancel = () => {
  setModalState((prev) => ({ ...prev, openSendEmailModal: false, openFor: "" }));
  setIspreview({ ...ispreview, emailPreview: false });
};

    const { selectedTitleCompanyData, selectedTitleCompanyLoading, selectedTitleCompanyError } = useSelector((state) => state.titleCompanyDetails);

    useEffect(() => {
        let sourceAxios = axios.CancelToken.source();
        let unmounted = { value: false };
        if (offerId) {
            dispatch(TitleCompanyHandle?.getSelectedTitleCompanyDataFromOffer({ offerId, openFor, accessToken, sourceAxios, unmounted }))
        } else if (propertyId) {
            dispatch(TitleCompanyHandle?.getSelectedTitleCompanyDataFromOffer({ propertyId, openFor, accessToken, sourceAxios, unmounted }))
        }
        return () => {
            unmounted.value = true;
            sourceAxios.cancel("Component unmounted, request cancelled.");
        }
    }, [])

    const [titleCompanyEmails, setTitleCompanyEmails] = useState([]);

    useEffect(() => {
        if (Object.keys(selectedTitleCompanyData)?.length > 0) {
            const emails = [];

            // SALES REPS
            if (selectedTitleCompanyData?.salesRepName && selectedTitleCompanyData?.salesRepEmail?.length) {
                emails.push({
                    name: selectedTitleCompanyData.salesRepName,
                    email: selectedTitleCompanyData.salesRepEmail,
                });
            }

            // CLOSERS
            if (selectedTitleCompanyData?.titleCloserName && selectedTitleCompanyData?.titleCloserEmail?.length) {
                emails.push({
                    name: selectedTitleCompanyData.titleCloserName,
                    email: selectedTitleCompanyData.titleCloserEmail,
                });
            }

            // TITLE OFFICE MAILS
            if (selectedTitleCompanyData?.titleOfficeName && selectedTitleCompanyData?.titleOfficeEmail?.length) {
                emails.push({
                    name: selectedTitleCompanyData.titleOfficeName,
                    email: selectedTitleCompanyData.titleOfficeEmail,
                });
            }

            // TITLE COMPANY MAILS
            if (selectedTitleCompanyData?.titleCompanyName && selectedTitleCompanyData?.titleCompanyEmail?.length) {
                emails.push({
                    name: selectedTitleCompanyData.titleCompanyName,
                    email: selectedTitleCompanyData.titleCompanyEmail,
                });
            }

            // PROCESSORS
            if (selectedTitleCompanyData?.processors?.length > 0) {
                selectedTitleCompanyData.processors.forEach((el) => {
                    if (el?.name && el?.email?.length) {
                        emails.push({
                            name: el.name,
                            email: el.email,
                        });
                    }
                });
            }

            // OTHER AFFILIATES
            // if (selectedTitleCompanyData?.affiliateDetails?.affiliates?.length > 0) {
            //     selectedTitleCompanyData.affiliateDetails.affiliates.forEach((el) => {
            //         if (el?.name && el?.email?.length) {
            //             emails.push({
            //                 name: el.name,
            //                 email: el.email,
            //             });
            //         }
            //     });
            // }

            setTitleCompanyEmails(emails);
        } else {
            setTitleCompanyEmails([]); // Reset if no data
        }
    }, [selectedTitleCompanyData]);

    const selectedEmails = selectedTitleCoRecipients.map((recipient) => recipient.email);

    const rowSelection = {
        selectedRowKeys: selectedEmails,
        onChange: (selectedRowKeys, selectedRows) => {
            const updatedRecipients = selectedRows.map((row) => ({
                ...row,
                recipientType: "TITLE_COMPANY",
            }));
            setSelectedTitleCoRecipients(updatedRecipients);
        },
        getCheckboxProps: (record) => ({
            disabled: !record.email,
        }),
    };

    return (
        <>
        {/* {ispreview?.emailPreview && <EmailPreview ispreview={ispreview} setIspreview={setIspreview} 
        // clientsArray={clientsArray} allBuyerAgentData={allBuyerAgentData} allSellerAgentData={allSellerAgentData} emailSignatureId={emailSignatureId} selectedPersonsState={selectedPersonsState} subjectForm={subjectForm} 
        // emailPreviewClients={emailPreviewClients} combinedSameSideAgents={combinedClientsData?.combinedSameSideAgents}
emailPreviewData={emailPreviewData}
        />} */}
            <Modal
                title={<div className="commonModalTitle" >Send Contact Sheet To</div>}
                width={700}
                closable
                onCancel={handleCancel}
                visible={true}
                okText="Send"
                okButtonProps={{ disabled: (addedClients?.length <= 0) }}
                footer={[
                    <Button
                        key="cancel"
                        onClick={() => {
                            if (form.getFieldValue('email') || addedClients?.length) {
                                confirm({
                                    title: "Warning!",
                                    content: "Are you sure want to cancel sending this Contact Sheet?",
                                    onCancel: () => { },
                                    onOk: () => { setModalState((prev) => ({ ...prev, openSendEmailModal: false, openFor: "" })) },
                                    okText: "Yes",
                                    cancelText: "No"
                                })
                            } else {
                                setModalState((prev) => ({ ...prev, openSendEmailModal: false, openFor: "" }));
                            }
                        }}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="preview"
                        type="primary"
                        disabled={addedClients?.length <= 0 && selectedTitleCoRecipients?.length <= 0}
                        onClick={handleOpenEmailPreview}
                    >
                        Email Preview
                    </Button>,
                    <Button
                        key="send"
                        type="primary"
                        disabled={addedClients?.length <= 0 && selectedTitleCoRecipients?.length <= 0}
                        onClick={handleSend}
                    >
                        Send
                    </Button>
                ]}
            >
                <div className={styles.outerContainer}>
                    <div className={styles.selectEmails}>
                        <div className={styles.emailAddingOptionsContainer}>
                            <div className={styles.manualAddEmailBox}>
                                <Form
                                    form={form}
                                    layout="inline"
                                    scrollToFirstError
                                    onFinish={handleAdd}
                                >
                                    <div className={styles.formInnerContainer}>
                                        <div className={styles.formLabel}>EMAIL: </div>
                                        <Form.Item
                                            name="email"
                                            label={""}
                                            // rules={[{ type: 'email', message: "Not a valid Email!" }]}
                                            style={{ width: "50%" }}
                                        >
                                            <Input allowClear size='small' type='email' placeholder='Please Enter Email Here' />
                                        </Form.Item>
                                        <Form.Item shouldUpdate>
                                            {() => (
                                                <Button
                                                    size='small'
                                                    type="primary"
                                                    htmlType="submit"
                                                    disabled={!form.getFieldValue('email')}
                                                >
                                                    Add
                                                </Button>
                                            )}
                                        </Form.Item>
                                    </div>
                                </Form>
                            </div>
                            {(rootDocData?.openFor === 'TITLE_COMPANY') ? "" : <div className={styles.openClientListBtn}>
                                <Tooltip title="Add Email" placement="top">
                                    <PlusCircleFilled style={{ cursor: "pointer" }} onClick={() => { setOpenClientList(true) }} />
                                </Tooltip>
                            </div>}
                        </div>
                        <div className={styles.showSelectedEmails}>
                            <ul>
                                {addedClients?.length > 0 && addedClients.map((client) => {
                                    return <li key={client?.email}>
                                        <a href={`mailto: ${client?.email}`}>{client?.email}</a>
                                        <span style={{ marginLeft: "10px", cursor: "pointer" }} onClick={() => handleRemove(client?.email)}>
                                            <Tooltip title={"Delete Email Id"} placement="right">
                                                <DeleteOutlined style={{ color: '#178DFA' }} />
                                            </Tooltip>
                                        </span>
                                    </li>
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className={styles.sendToTitleCompanyContainer}>
                        <div className={styles.sendToTitleCompanyTitle}>Send Contact Sheet To Title Company</div>
                        <div className={styles.noteIndicator}>Note: This will send the Contact Sheet to the Title Company with their version of Contact Sheet.</div>
                        <div className={styles.sendToTitleCompanyCont1}>
                            <div>
                                <Table
                                    size='small'
                                    pagination={false}
                                    rowSelection={rowSelection}
                                    dataSource={titleCompanyEmails || []}
                                    loading={selectedTitleCompanyLoading}
                                    rowKey="email" // important for checkboxes to work with selectedRowKeys
                                    scroll={{x: '100%'}}
                                    columns={[
                                        {
                                            title: 'Name',
                                            dataIndex: 'name',
                                            key: 'name',
                                            render: (text) => <span style={{ color: "#178DFA" }}>{text}</span>,
                                        },
                                        {
                                            title: 'Email',
                                            dataIndex: 'email',
                                            key: 'email',
                                            render: (text) => <span>{text}</span>,
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
                    <SubjectLine form={subjectForm} source="CONTACT_SHEET"/>

                    <div className={styles.emailContents}>
                        <div style={{ fontWeight: "bold", padding: "5px" }}>Please Enter your message</div>
                        <div className={styles.emailSpace}>
                            <ReactQuill
                                value={emailContents}
                                onChange={handleEmailContentChange}
                                placeholder='Enter Message...'
                                formats={formats}
                                modules={modules}
                                className={styles.reactQuillComp}
                            />
                            {/* <textarea id='emailContents' name="emailContents" placeholder='Enter Message'></textarea> */}
                        </div>
                    </div>
                </div>
            </Modal>

            {/* MODAL FOR CLIENT LIST */}
            <Modal
                // title={<div style={{ textAlign: "center", color: "#178DFA" }}>SELECT CLIENT EMAIL</div>}
                width={500}
                style={{ top: "10vh" }}
                closable
                visible={openClientList}
                onCancel={() => setOpenClientList(false)}
                footer={null}
            >
                <ClientList onAdd={addClient} accessTokan={accessToken}  source="ContactSheet" addedClients={addedClients} />
            </Modal>
        </>
    )
}
